export const getFileNameFromContentDisposition = (
  header: string | null,
): string | null => {
  if (!header) return null;
  const match = header.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
  return match ? match[1].replace(/['"]/g, '') : null;
};
